import { useState } from 'react';
import { IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Download } from '@sweep-io/sweep-design/dist/icons';
import { usePdfExport } from './usePdfExport';
import { telemetry } from '../../../../telemetry';

interface ExportButtonProps {
  messageRef: React.RefObject<HTMLDivElement>;
  chatName?: string;
  onClickCb?: () => void;
}

export const PdfExportButton = ({ messageRef, chatName, onClickCb }: ExportButtonProps) => {
  const [isExporting, setIsExporting] = useState(false);
  const { exportToPdf } = usePdfExport();

  const handleExport = async () => {
    if (!messageRef.current) {
      telemetry.captureError(new Error('Message element not found'));
      return;
    }

    onClickCb?.();

    setIsExporting(true);
    try {
      await exportToPdf(messageRef.current, chatName);
    } catch (error) {
      telemetry.captureError(new Error('PDF export failed'), error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Tooltip title="Export to PDF" placement="top">
      <span>
        <IconButton onClick={handleExport} disabled={isExporting} size="tiny" variant="flat">
          <Download />
        </IconButton>
      </span>
    </Tooltip>
  );
};
